import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { IDataCardProgram } from "../../../../../models/data-card.model"
import { HttpErrorResponse } from "@angular/common/http"
import { DataCardService } from "../../../../../services/data-card.service"
import { HttpResponseHandlerService } from "../../../../../services/http-response-handler.service"
import {
  MainObjectDataCardTemplateComponent
} from "../../main-object-data-card-template/main-object-data-card-template.component"
import { NzDrawerService } from "ng-zorro-antd/drawer"

@Component({
  selector: 'app-program-modal',
  templateUrl: './program-modal.component.html',
  styleUrls: ['./program-modal.component.scss'],
  standalone: false,
})
export class ProgramModalComponent {
  @Input({ required: true }) program: string

  private _item: IDataCardProgram | null = null
  private _isLoading: boolean = false

  public get item(): IDataCardProgram | null {
    return this._item
  }

  public get isLoading(): boolean {
    return this._isLoading
  }

  constructor(
    private activeModal: NgbActiveModal,
    private drawerService: NzDrawerService,
    private dataCardService: DataCardService,
    private responseHandlerService: HttpResponseHandlerService,
  ) {}

  public cancel(): void {
    this.activeModal.dismiss({})
  }

  public onDataCardDrawerOpen(mainObject: string): void {
    this.drawerService.create<MainObjectDataCardTemplateComponent, { mo: string }, any>({
      nzTitle: 'Datacard',
      nzWidth: '500px',
      nzContent: MainObjectDataCardTemplateComponent,
      nzData: { mo: mainObject },
    })
  }

  private getNotificationData(): void {
    this._isLoading = true
    this.dataCardService.getProgramData(this.program).subscribe({
      next: (resource: IDataCardProgram): void => {
        this._item = resource
        this._isLoading = false
      },
      error: (error: HttpErrorResponse): void => {
        this.responseHandlerService.notifyError(error)
        this._isLoading = false
      },
    })
  }

  public ngOnInit(): void {
    this.getNotificationData()
  }
}
